export type LoadBalancer = {
  id: string;
  name: string;
  locationId: string;
  capacityKw: number;
  parentLbId: string | null;
  active: boolean;
};

export enum FlexiChargingConnectorType {
  Ac,
  Dc,
}

export type DefaultFlexiPlan = {
  id?: string;
  locationId?: string;
  connectorType: FlexiChargingConnectorType | null;
  maxAcPower: number | null;
  maxDcPower: number | null;
  requestedKwh: number;
  durationHours: number;
  overtimeCharging: boolean;
};

export type SmartProfileSummary = {
    transactionId: number | null
    targetEnergyKwh: number
    totalPlannedEnergyKwh: number
    from: string
    to: string
    connectorType: string
    calculationTimeLocal: string
    schedule: SmartProfilePeriod[]
    overtimeCharging: boolean
}

export type SmartProfilePeriod = {
    startPeriod: number
    from: string
    to: string
    limit: string
    power: string
    energy: string
    pricePerKwh: string
    cost: string
    startTimeLocal: string
    powerValue: number
    dateLabel: string
    isNextDay: boolean
}